var React = require('react');

function ArrowSeeMore (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","strokeWidth":"2","strokeLinecap":"square","d":"M14.7 7.8H1.2","key":0}),React.createElement("path",{"fill":"none","strokeWidth":"2","d":"M9 1.3l6.8 6.5L9 14.3","key":1})]);
}

ArrowSeeMore.displayName = "ArrowSeeMore";

ArrowSeeMore.defaultProps = {"viewBox":"0 0 18 15"};

module.exports = ArrowSeeMore;

ArrowSeeMore.default = ArrowSeeMore;
